import { EventStatus } from "@/types/enums/event";
import type { EventDetail } from "@/types/event";

type SidebarAppointment = Pick<EventDetail, "start" | "status">;

export function getPatientSidebarAppointmentGroups<
  T extends SidebarAppointment,
>(events: readonly T[] | null | undefined, now = new Date()) {
  const nowMs = now.getTime();
  const appointmentsWithStart = (events ?? []).filter(
    (event) => event.start && Number.isFinite(new Date(event.start).getTime()),
  );

  const upcomingAppointments = appointmentsWithStart
    .filter((event) => new Date(event.start).getTime() > nowMs)
    .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

  const pastAppointments = appointmentsWithStart
    .filter(
      (event) =>
        new Date(event.start).getTime() <= nowMs &&
        event.status === EventStatus.COMPLETED,
    )
    .sort((a, b) => new Date(b.start).getTime() - new Date(a.start).getTime());

  return { upcomingAppointments, pastAppointments };
}
